import React, { useState, useEffect } from "react";
import { v4 as uuidv4 } from "uuid";
import {
    Col,
    Row,
    Container,
    Table,
    Pagination,
    PaginationItem,
    PaginationLink,
    ButtonDropdown,
    FormGroup,
    Input,
    FormText,
    Dropdown,
    DropdownMenu,
    DropdownToggle,
    DropdownItem,
    Label,
    Badge,
    Card,
    CardTitle,
    CardBody,
    options
} from "reactstrap";
import Select from "react-select";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import mock from "../tables/mock";
import Widget from "../../components/Widget/Widget.js";
import s from "../tables/Tables.module.scss";
import moreIcon from "../../assets/tables/moreIcon.svg";
import Starrating from "../../assets/tables/Start.png";
import { useHistory } from 'react-router-dom';
import 'react-notifications/lib/notifications.css';
import { MultiSelect } from "react-multi-select-component";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import "../../styles/tost.css"
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import baseURL from "../../api/apiurl"
import BaseAPI from '../../api/apiurl.js';





const Useradd = function () {
    const [selectedDate, setSelectedDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [staff, setStaff] = useState('');
    const [designation, setDesignation] = useState('');
    const [userName, setUserName] = useState('');
    const [domainName, setDomainName] = useState('');
    const [password, setPassword] = useState('');
    const [mobileNo, setMobileNo] = useState('');
    const [imeNo, setImeNo] = useState('');
    const [email, setEmail] = useState('');
    const [staffName, setStaffName] = useState('');
    const [responseMessage, setResponseMessage] = useState('');
    const [customerId, setCustomerId] = useState('');
    const [companyId, setCompanyId] = useState('');
    const [entityOptions, setEntityOptions] = useState([]); // project droupdown
    const [submitted, setSubmitted] = useState(false);
    const [formSubmitted, setFormSubmitted] = useState(false);
    const [formSubmitteds, setFormSubmitteds] = useState(false);






    const history = useHistory();

    const handleDateChange = (date) => {
        setSelectedDate(date);
    };

    const handleDateChange2 = (date) => {
        setEndDate(date);
    };

    const options = [
        { value: 'admin', label: 'Admin' },
        { value: 'user', label: 'User' }

    ]
    const optionsmodule = [
        { label: "Service", value: "service" },
        { label: "Project", value: "project" }
    ];



    const buttonstyle = {
        display: 'flex',
        alignItems: 'center',
    };

    const handleClickUserview = () => {
        history.push('/timeinlive/User');
    };


    const [firstTable] = useState(mock.firstTable);
    const [secondTable] = useState(mock.secondTable);
    const [secondTableCurrentPage, setSecondTableCurrentPage] = useState(0); //
    const [tableDropdownOpen, setTableMenuOpen] = useState(false); //
    const [selectedValue, setSelectedValue] = useState(null);
    const [selectedValueModule, setSelectedValueModule] = useState([]);
    const [selectedValueproject, setSelectedValueproject] = useState([]);

    const [showPassword, setShowPassword] = useState(false); // show password


    const pageSize = 10;




    const setSecondTablePage = (e, index) => {
        e.preventDefault();
        setSecondTableCurrentPage(index);
    }

    const tableMenuOpen = () => {
        setTableMenuOpen(!tableDropdownOpen);
    } //

    const handleChange = (selectedOption) => {
        setSelectedValue(selectedOption.value);
    };

    // const handleChangeModule = (selectedOptionsModule) => {
    //     setSelectedValueModule(selectedOptionsModule);
    // };

    const handlePasswordToggle = () => {
        setShowPassword(!showPassword);
    };

    const fetchEntityOptions = async () => {
        try {
            const url = `${BaseAPI}project`;
            const companyId = localStorage.getItem('companyid');
            const customerId = localStorage.getItem('customerid');
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    // You might need to add other headers if required (e.g., authorization headers)
                },
                body: JSON.stringify({
                    company_id: companyId,
                    customer_id: customerId
                }),

            });

            if (!response.ok) {
                throw new Error('Network response was not ok.');
            }   

            const data = await response.json();
            setEntityOptions(data.data.map(item => ({ label: item.entityname, value: item.id })));
        } catch (error) {
            console.error('Error:', error);
            // Handle the error here if needed
        }
    };

    console.log("projectvalue", entityOptions);


    const handleSubmit = async () => {

        setSubmitted(true);
        try {
            const url = `${BaseAPI}staffadd`;
            const params = {
                staff: staff,
                designation: designation,
                user_name: `${staff}@${domainName}`,
                password: password,
                mobile_no: mobileNo,
                ime_no: imeNo,
                email: email,
                staffname: staffName,
                company_id: companyId,
                customer_id: customerId,
                account: selectedValue,
                modules: selectedValuesString,
                // modules: JSON.stringify(selectedValueModule),
                project_id: selectedProjectString
            };


            const response = await fetch(`${url}?${new URLSearchParams(params)}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
            });

            if (!response.ok) {
                const errorData = await response.json();
                if (errorData.error) {
                    // Handle specific error cases
                    if (errorData.error === 'Username is already in use. Please choose a different username.') {
                        toast.error('Duplicate User Name detected.choose a different User Name.', {
                            autoClose: 3000,
                            position: 'top-center',
                            className: 'custom-toast-error',
                        });
                    } else if (errorData.error === 'User ID is already in use. Please choose a different staff ID.') {
                        toast.error('Duplicate User ID detected.choose a different User ID.', {
                            autoClose: 3000,
                            position: 'top-center',
                            className: 'custom-toast-error',
                        });
                    }
                    else {
                        toast.error('Error occurred while adding data. Please try again.', {
                            autoClose: 3000,
                            position: 'top-center',
                            className: 'custom-toast-error',
                        });
                    }
                } else {
                    toast.error('Please fill in all these fields and then Submit', {
                        autoClose: 3000,
                        position: 'top-center',
                        className: 'custom-toast-error',
                    });
                }
            } else {
                const data = await response.json();
                setResponseMessage(data.message);
                toast.success('Data Added Successfully!', {
                    autoClose: 1500,
                    position: 'top-center',
                    className: 'custom-toast-success',
                });
                await new Promise((resolve) => setTimeout(resolve, 1500));
                history.push('/timeinlive/user');
            }
        } catch (error) {
            console.error('Error:', error);
            toast.error('Error occurred while making the API request.', {
                autoClose: 3000,
                position: 'top-center',
                className: 'custom-toast-error',
            });
        }
    };

    React.useEffect(() => {
        const customerId = localStorage.getItem('customerid');
        const companyId = localStorage.getItem('companyid');
        if (customerId) {
            setCustomerId(customerId);
        }
        if (companyId) {
            setCompanyId(companyId);
        }
        fetchEntityOptions();
    }, []);

    useEffect(() => {
        // Fetch the domain name from local storage
        const storedDomain = localStorage.getItem('domain');
        if (storedDomain) {
            setDomainName(storedDomain);
        }
    }, []);

    const selectedValues = selectedValueModule.map(option => option.value);
    const selectedValuesString = selectedValues.join(', ');

    const selectedProject = selectedValueproject.map(option => option.value);
    const selectedProjectString = selectedProject.join(', ');

    return (

        <Container fluid>
            <br></br> <br></br>
            <Card >

                <CardBody style={{ whiteSpace: 'nowrap' }}>
                    <div className="row mt-6">
                        <div className="col-sm-4">
                            <div className="mb-4 row flex-column  ">
                                <label htmlFor="assetCode" className="col-sm-3 col-form-label label-required ">User ID</label>
                                {/* <div className="col-sm-10">
                                    <input type="text"
                                        className="form-control"
                                        id="inputPassword"
                                        placeholder="Enter the User Id"
                                        value={staff}
                                        onChange={(e) =>{ setStaff(e.target.value);
                                            setFormSubmitteds(true); }}
                                        required
                                        aria-required="true" />
                                    {submitted && staff === '' && (
                                        <FormText color="danger">Please enter the User ID</FormText>
                                    )}
                                </div> */}
                                <div className="col-sm-10 input-group">
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="inputPassword"
                                        placeholder="Enter the User ID"
                                        value={staff}
                                        onChange={(e) => {
                                            setStaff(e.target.value);
                                            setFormSubmitteds(true);
                                        }}
                                        required
                                    />
                                    <div className="input-group-append">
                                        <span className="password-toggle input-group-text">@{domainName}</span>
                                    </div>
                                </div>

                                {formSubmitteds && (
                                    <FormText color="danger">User ID Once added, it is not changeable</FormText>
                                )}
                            </div>

                            <div className="mb-4 row flex-column  ">
                                <label htmlFor="assetCode" className="col-sm-3 col-form-label label-required ">Name</label>
                                <div className="col-sm-10">
                                    <input type="text" className="form-control" id="inputPassword" placeholder="Enter the Name" value={staffName} onChange={(e) => setStaffName(e.target.value)} />
                                    {submitted && staffName === '' && (
                                        <FormText color="danger">Please Enter the Name </FormText>
                                    )}
                                </div>
                            </div>

                            <div className="mb-4 row flex-column  ">
                                <label htmlFor="assetCode" className="col-sm-3 col-form-label label-required ">Email</label>
                                <div className="col-sm-10">
                                    <input type="email"
                                        className="form-control"
                                        id="inputPassword"
                                        placeholder="Enter the Email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        required
                                        aria-required="true" />
                                    {submitted && email === '' && (
                                        <FormText color="danger">Please enter the Email</FormText>
                                    )}
                                </div>
                            </div>



                            {/* <div className="mb-4 row flex-column">
  <label htmlFor="assetCode" className="col-sm-3 col-form-label label-required">Password</label>
  <div className="col-sm-10 input-group">
    <input
      type={showPassword ? 'text' : 'password'}
      className="form-control"
      id="inputPassword"
      placeholder="Enter the Password"
      value={password}
      onChange={(e) => setPassword(e.target.value)}
    />
    <div className="input-group-append">
    <span  className= "password-toggle input-group-text" >@{domainName}</span>
    </div>
  </div>
  {submitted && password === '' && (
    <FormText color="danger">Please enter the password</FormText>
  )}
</div> */}
                            <div className="mb-4 row flex-column  ">
                                <label htmlFor="assetCode" className="col-sm-3 col-form-label label-required ">
                                    Choose Projects
                                    <span className="required" style={{ color: 'red' }}>*</span>
                                </label>
                                <div className="col-sm-10">
                                    <Select
                                        isMulti
                                        className="select2-selection"
                                        placeholder="Choose..."
                                        options={entityOptions}
                                        value={selectedValueproject}
                                        onChange={setSelectedValueproject}
                                    />


                                </div>
                            </div>
                        </div>
                        <div className="col-sm-4">
                        <div className="mb-4 row flex-column  ">
                                <label htmlFor="assetCode" className="col-sm-3 col-form-label label-required ">Select Role <span className="required" style={{ color: 'red' }}>*</span></label>
                                <div className="col-sm-10">
                                    <Select
                                        classNamePrefix="select2-selection"
                                        placeholder="Choose..."
                                        title="Asset Form"
                                        options={options}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>
                            
                            {/* <div className="mb-4 row flex-column">
    <label htmlFor="assetCode" className="col-sm-3 col-form-label label-required">User Name</label>
    <div className="col-sm-10 input-group">
        <input
            type="text"
            className="form-control"
            id="inputPassword"
            placeholder="Enter the User Name"
            value={`${userName}`}
            onChange={(e) => {
                setUserName(e.target.value);
                setFormSubmitted(true); // Set formSubmitted to true
            }}
        />
        <div className="input-group-append">
            <span className="password-toggle input-group-text">@{domainName}</span>
        </div>
    </div>
    {submitted && userName === '' && (
        <FormText color="danger">Please Enter the User Name</FormText>
    )}
    {formSubmitted  && (
    <FormText color="danger">UserName Once added, it is not changeable</FormText>
)}
</div> */}
<div className="mb-4 row flex-column  ">
                                <label htmlFor="assetCode" className="col-sm-3 col-form-label label-required ">Designation</label>
                                <div className="col-sm-10">
                                    <input type="text" className="form-control" id="inputPassword" placeholder="Enter the Designation" value={designation} onChange={(e) => setDesignation(e.target.value)} />
                                    {submitted && designation === '' && (
                                        <FormText color="danger">Please Enter the Designation</FormText>
                                    )}
                                </div>
                            </div>

                            <div className="mb-4 row flex-column  ">
                                <label htmlFor="assetCode" className="col-sm-3 col-form-label label-required ">Mobile Number</label>
                                <div className="col-sm-10">
                                    <input type="text" className="form-control" id="inputPassword" placeholder="Enter the Mobile Number" value={mobileNo} onChange={(e) => setMobileNo(e.target.value)} />
                                    {submitted && mobileNo === '' && (
                                        <FormText color="danger">Please Enter the Mobile Number</FormText>
                                    )}
                                </div>
                            </div>
                            <div className="mb-4 row flex-column  ">
                                <label htmlFor="assetCode" className="col-sm-3 col-form-label label-required ">Choose Modules <span className="required" style={{ color: 'red' }}>*</span></label>
                                <div className="col-sm-10">
                                    <Select
                                        isMulti
                                        className="select2-selection"
                                        placeholder="Choose..."
                                        options={optionsmodule}
                                        value={selectedValueModule}
                                        onChange={setSelectedValueModule}
                                    />
                                </div>
                                {/* <pre>{JSON.stringify(selectedValuesString)}</pre> */}
                            </div>

                            {/* <div className="mb-4 row flex-column">
            <label className="col-sm-3 col-form-label">Selected Modules</label>
            <div className="col-sm-10">
                <input type="text" className="form-control" value={selectedValuesString} readOnly />
            </div>
        </div> */}
                        </div>
                        <div className="col-sm-4">
                        <div className="mb-4 row flex-column">
                                <label htmlFor="assetCode" className="col-sm-3 col-form-label label-required">Password</label>
                                <div className="col-sm-10 input-group">
                                    <input
                                        type={showPassword ? 'text' : 'password'}
                                        className="form-control"
                                        id="inputPassword"
                                        placeholder="Enter the Password"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                    />
                                    <div className="input-group-append">
                                        <span
                                            onClick={handlePasswordToggle}
                                            className={`password-toggle input-group-text ${showPassword ? 'show' : 'hide'}`}
                                        >
                                            <FontAwesomeIcon icon={showPassword ? faEye : faEyeSlash} />
                                        </span>
                                    </div>
                                </div>
                                {submitted && password === '' && (
                                    <FormText color="danger">Please enter the password</FormText>
                                )}
                            </div>
                            
                            {/* <div className="mb-4 row flex-column">
                                <label htmlFor="assetCode" className="col-sm-3 col-form-label label-required">User Name</label>
                                <div className="col-sm-10 input-group">
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="inputPassword"
                                        placeholder="Enter the User Name"
                                        value={`${userName}`}
                                        onChange={(e) => setUserName(e.target.value)}
                                    />
                                    <div className="input-group-append">
                                        <span className="password-toggle input-group-text" >@{domainName}</span>
                                    </div>
                                </div>
                                {submitted && userName === '' && (
                                    <FormText color="danger">Please Enter the User Name</FormText>
                                )}
                            </div> */}
                           


                            <div className="mb-4 row flex-column  ">
                                <label htmlFor="assetCode" className="col-sm-3 col-form-label label-required ">UID Number</label>
                                <div className="col-sm-10">
                                    <input type="text" className="form-control" id="input" placeholder="Enter the UID Number" value={imeNo} onChange={(e) => setImeNo(e.target.value)} />
                                </div>
                            </div>
                            {/* <div className="mb-4 row flex-column  ">
                            <input type="text" className="form-control" id="inputPassword" placeholder="Enter the User Name" value={companyId} onChange={(e) => setUserName(e.target.value)}/>
                                    <input type="text" className="form-control" id="inputPassword" placeholder="Enter the User Name" value={customerId} onChange={(e) => setUserName(e.target.value)}/>
                                </div> */}
                        </div>
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <button type="button" onClick={handleClickUserview} className="btn btn-primary" style={{ padding: "5px 20px" }}> <i className="fa fa-window-close" style={{ fontSize: "16px" }} />&nbsp; Cancel</button> &nbsp;&nbsp;
                        <button type="button" className="btn btn-primary" style={{ padding: "5px 10px", }} onClick={handleSubmit}><i className="fa fa-plus-circle" style={{ fontSize: "16px" }} />&nbsp; Submit</button>
                    </div>


                </CardBody>
            </Card>
            &nbsp;  &nbsp;  &nbsp;
            <div>
            </div>
            <ToastContainer />
        </Container>



    )
}

export default Useradd;
